import { Box, Stack, TextField, useTheme } from '@mui/material'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'
import React, { useEffect, useState } from 'react'
import { IsNotEmpty, FormatDate } from '../Helpers'
import { I18N } from '../I18N'
import { DevelopmentItem } from '../models/dtos'
import { AdapterDayjs as DateAdapter } from '@mui/x-date-pickers/AdapterDayjs';
import DevelopmentClient from '../apiClients/DevelopmentClient'

export interface DevelopmentItemCompleteComponentProps {
    developmentItem: DevelopmentItem;
    onChange: () => void;
}

const DevelopmentItemCompleteComponent = ({ developmentItem, onChange = () => { } }: DevelopmentItemCompleteComponentProps) => {

    const theme = useTheme();

    const [completedMinDate, setCompletedMinDate] = useState<Dayjs>(dayjs());
    const [completedDate, setCompletedDate] = useState<Dayjs>(dayjs());

    useEffect(() => {
        setCompletedMinDate(dayjs(developmentItem.StartDate).add(1, 'day'));
    }, [developmentItem])

    const handleCompletedDateChanged = (value: Dayjs) => {
        setCompletedDate(value);
        developmentItem.CompleteDate = value.toISOString();

        onChange();
    }

    return (
        <>
            <Box sx={{ width: '100%', paddingTop: '1em' }}>
                <Stack spacing={theme.spacing(3)} sx={{ }}>
                    <TextField label={I18N.Translate("Development Item")} fullWidth
                        name="Narrative" sx={{ color: 'theme.primary', fontSize: 'medium' }}
                        disabled={true}
                        size="small"
                        variant="outlined"
                        multiline={true}
                        minRows={10}
                        maxRows={10}
                        value={developmentItem.Narrative} />
                    <TextField label={I18N.Translate("Start Date")} fullWidth
                        name="StartDate"
                        disabled={true}
                        sx={{ width: '30%', fontSize: 'small' }}
                        size="small"
                        variant="outlined"
                        value={(IsNotEmpty(developmentItem.StartDate)) ? FormatDate(dayjs(developmentItem.StartDate)) : ''} />
                    <Box sx={{ width: '30%' }}>
                        <LocalizationProvider dateAdapter={DateAdapter}>
                            <DatePicker autoFocus
                                label={I18N.Translate("Completed Date")}
                                disabled={!DevelopmentClient.RuleStartDateBeforeToday(developmentItem.StartDate) || DevelopmentClient.RuleItemCompleted(developmentItem.CompleteDate)}
                                minDate={completedMinDate}
                                maxDate={dayjs()}
                                value={completedDate}
                                onChange={(newValue) => handleCompletedDateChanged(newValue)}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                            />
                        </LocalizationProvider>
                    </Box>
                </Stack>
            </Box>
        </>
    )
}

export default DevelopmentItemCompleteComponent